export default __webpack_public_path__ + "static/media/fabricantes.727cc79c.jpg";